import React, {HTMLAttributeAnchorTarget} from "react";

import {Text} from "@pg-design/text-module";
import {FOOTER_TEST_IDS} from "@pg-mono/test-ids";

import * as styles from "./FooterMenuElement.module.css";

export interface IFooterMenuElement {
    title: string;
    url?: string;
    rel?: string;
    target?: HTMLAttributeAnchorTarget;
    titleAttribute?: string;
    onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

export const FooterMenuElement: React.FC<IFooterMenuElement> = (props) => {
    return (
        <li className={styles.menuLi} data-testid={FOOTER_TEST_IDS.FOOTER_ELEMENT}>
            <a className={styles.link} href={props.url} rel={props.rel} target={props.target} title={props.titleAttribute} onClick={props.onClick}>
                <Text variant="info_txt_1">{props.title}</Text>
            </a>
        </li>
    );
};
import React, {HTMLAttributeAnchorTarget} from "react";

import {Text} from "@pg-design/text-module";
import {FOOTER_TEST_IDS} from "@pg-mono/test-ids";

import * as styles from "./FooterMenuElement.module.css";

export interface IFooterMenuElement {
    title: string;
    url?: string;
    rel?: string;
    target?: HTMLAttributeAnchorTarget;
    titleAttribute?: string;
    onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

export const FooterMenuElement: React.FC<IFooterMenuElement> = (props) => {
    return (
        <li className={styles.menuLi} data-testid={FOOTER_TEST_IDS.FOOTER_ELEMENT}>
            <a className={styles.link} href={props.url} rel={props.rel} target={props.target} title={props.titleAttribute} onClick={props.onClick}>
                <Text variant="info_txt_1">{props.title}</Text>
            </a>
        </li>
    );
};
